import React from "react";
import './footer.css';


function Footer(props){
    const date = new Date;
    return(
        <>
            <div className='first-verify__left-footer'>
                <span className='contact-us text-align-center'>
                    If you are having issues with any portion of the website, please contact us.
                </span>
                <div className='left-footer-option-container'>
                <a href="mailto:support@firstverify.com"><span className='contact-email'>support@firstverify.com</span></a> 
                 <a href="tel:(402) 562-5930"><span className='phone-number'>(402) 562-5930</span></a> 
                </div>
                <div className='left-footer-suboption-container mt-3'>
                 <a href="/terms_and_conditions" target="blank"><span className='suboption-container-options'>Terms & Conditions</span></a> 
                 <a href="Statement_of_Privacy" target="blank">  <span className='suboption-container-options'>Privacy Policy</span></a>
                 <a href="/Contact_us"target="blank">  <span className='suboption-container-options'>Contact us</span></a>
                 <a href="https://www.firstverify.com" target="blank">  <span className='suboption-container-options'>FirstVerify.com</span></a>
                </div>

                <br/>
                <div className='left-footer-suboption-container text-align-center '>
                    <span className='copyright-label'>&#xA9; 2014-{date?.getUTCFullYear()} FIRST, VERIFY. All Rights Reserved. </span>
                </div>
            </div>
        </>
    )
}

export default Footer;